<script>
export default {
    type: "mscombidy2d",
                width: "100%",
                height: "350",
                dataFormat: "json",
                dataSource: {
                    chart: {
                        // caption: "Split of visitors by Channels",
                        // placevaluesinside: "1",
                        // showvalues: "1",
                        // plottooltext:
                        //     "<b>$dataValue</b> $seriesName Pada $label",
                        theme: "fusion",
                        caption: "JUMLAH HASIL DAERAH",
                        // xAxisname: "Month",
                        pYAxisName: "Jumlah Kutipan",
                        sYAxisName: "Peratus %",
                        // numberPrefix: "$",
                        sNumberSuffix: "%",
                        // sYAxisMaxValue: "300",
                    },
                    categories: [
                        {
                            category: [
                                {
                                    label: "April 2022",
                                },
                                {
                                    label: "April 2021",
                                },
                                {
                                    label: "April 2020",
                                },
                            ],
                        },
                    ],
                    dataset: [
                        {
                            seriesname: "Anggaran",
                            color: "#F76E11",
                            data: [
                                { value: "13505610.00" },
                                { value: "12207340.00 	" },
                                { value: "17166110.00 " },
                            ],
                        },
                        {
                            seriesname: "Kutipan",
                            color: "#FF9F45",
                            data: [
                                { value: "1864165.25 " },
                                { value: "715729.60 " },
                                { value: "4587450.90 	" },
                            ],
                        },
                        {
                            seriesName: "Peratus %",
                            parentYAxis: "S",
                            renderAs: "line",
                            showValues: "0",
                            color: "#000000",
                            data: [
                                {
                                    value: "13.80",
                                },
                                {
                                    value: "5.86",
                                },
                                {
                                    value: "26.72",
                                },
                            ],
                        },
                    ],
                },
};
</script>
